import { SVGProps } from 'react';

type Props = {
    CardImage: ((value: SVGProps<SVGSVGElement>) => React.ReactElement);
    heading: string;
};
const SupportCard = (props: Props) => {
    const { CardImage, heading } = props;

    return (
        <button
            className={[
                'w-auto p-8 gap-y-6 mr-10 mb-6',
                'bg-white border-1.5 shadow-card border-card-normal rounded-md',
                'hover:border-card-hover outline-0 focus-visible:border-card-hover active:shadow-none',
            ].join(' ')}
            style={{
                height: '15.5rem',
                width: '18rem',
            }}
            type="button"
        >
            <div className='flex flex-col items-stretch h-max w-maxPrac'>
                <div className='self-center p-2'>
                    <CardImage height="6rem" className='fill-validation-info ' />
                </div>
                <span className='h-half' >
                    <h2 className="text-label-lg font-bold" >
                        { heading }
                    </h2>
                </span>
            </div>
        </button>
    );
};

export default SupportCard;